// GlobalStyles.js
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
 * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Poppins', sans-serif;
  background: #000;
  color: #fff;
  overflow-x: hidden;
}


  a {
    text-decoration: none;
    color: inherit;
  }

  section {
    padding: 80px 20px;
  }
`;

export default GlobalStyle;
